
import React, { Component } from "react";
import PageTitle from "../Theme/PageTitle/index.js";
import DashboardLayout from "../Theme/DashboardLayout/index.js";
import { Button, Col, Modal, Row, Table } from "antd";
import Widget from "../Theme/Widget/index.js";
import { useNavigate } from 'react-router-dom';
import { StrokeIcon } from "../Theme/Icon/index.js";
import Spinner from '../Theme/Spinner/index.js';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AuthLogic from '../../AuthLogic/index.js';
import { bindActionCreators } from "redux";
import * as postedScheduleActions from '../../redux/actions/postedScheduleActions.js';
import * as resourceActions from '../../redux/actions/resourceActions.js';
import SelectResourceButton from '../SelectResource/SelectResourceButton.js';
import PostedSchedulesList from './PostedSchedulesList.js';
import PreviousPostingsList from './PreviousPostingsList.js';
import generateListPostedSchedulesArray from './generateListPostedSchedulesArray.js';
import generateListPreviousPostingsArrays from './generateListPreviousPostingsArrays.js';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc.js'
dayjs.extend(utc);

/**
 * The full page for viewing the options of posted schedules to view. It displays a title and the resource at the top of the page,
 * the PostedSchedulesList with all the possible schedules to view, and finally has a look up component at the botton to search for
 * another resource.
 */
class PostedSchedulesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            resource: '',
            listPostedSchedulesArray: [],
            listPreviousPostingsArrays: {},
            displayPreviousPostings: false,
            postedSchedule: '',
            previousPostings: '',
            findResourceModal: false,
            areSearchFieldsValid: true,
            findResourceFields: {
                name: '',
                sso: '',
                withDisabled: false
            },
            resources: '',
            resourceTable: {
                columns: [
                    {
                        title: 'Resource name',
                        dataIndex: 'name',
                        render: text => <a>{text}</a>
                    },
                    {
                        title: 'Cost Center Name',
                        dataIndex: 'dName',
                        render: text => <a>{text}</a>
                    },
                ],
                data: ''
            },
        };
    }

    // Need to always reset state here because each new mounting means a new resource(person) has been selected
    async componentDidMount() {
        this.updateResource();
    }

    getListPostedSchedulesArray = async () => {
        let resourceId = this.state.resource.id || this.props.user.login.resourceId;
        await this.props.actions.fetchListPostedSchedules(resourceId).catch(error => {
            alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
        });
        this.setState({
            listPostedSchedulesArray: generateListPostedSchedulesArray(this.props.listPostedSchedules),
            loaded: true
        });
    }

    getListPreviousPostingsArrays = async () => {
        let resourceId = this.state.resource.id || this.props.user.login.resourceId;
        await this.props.actions.fetchListPreviousPostings(resourceId).catch(error => {
            //alert("loading list of previous postings failed\n" + JSON.stringify(error));
        });
        // console.log(this.props.listPreviousPostings) debug
        this.setState({
            listPreviousPostingsArrays: generateListPreviousPostingsArrays(this.props.listPreviousPostings)
        });
    }

    handleSelectSchedule = async (elem) => {        
        const { id, scheduleFormat } = elem;
        if (elem.Id !== -1) {
            this.setState({
                 startDate: elem.startDate,
                scheduleFormat,
                postedId: id, // from PostedSchedulesListArray
                loaded: false // trigger spinner (avoid delay after clicking desired postedSched)
            }, async () => {
                // here call fetchPostedSchedule just for the purpose of getting the full startDate, don't keep anything else
                await this.props.actions.fetchPostedSchedules('null', 0, this.state.postedId, 'null', 'null').catch(error => {
                    alert("Loading posted schedules failed" + JSON.stringify(error));
                  });

                  this.setState({
                    postedSchedule: await this.props.postedSchedule,
                    startDate: await dayjs(this.props.postedSchedule.startDate).utc().format('YYYY-MM-DD') // startDate from PostScheduleLoad storedProc
                  }, () => {
                    this.setState({
                        loaded: true,
                    });
                    let pathname= (this.state.scheduleFormat === 7 || this.state.scheduleFormat === 9)
                    ? '/posted-schedule-view-long' : '/posted-schedule-view-short';
                    let state= {
                        resource: this.state.resource,
                        startDate: dayjs(this.state.startDate).format('YYYY-MM-DD'),
                        scheduleFormat: this.state.scheduleFormat,
                        postedId: this.state.postedId
                    }
                    this.props.navigate(pathname,{state: state});
                });
            });
        }
    }

    handleClickPreviousPostings = () => {
        this.setState((prevState) => ({
            displayPreviousPostings: !prevState.displayPreviousPostings
        }));
    }

    updateResource = () => {
        let resource = {
            id: this.props.selectedResource.id || this.props.user.login.resourceId,
            name: this.props.selectedResource.name || this.props.user.userDemographics.name
        }
        this.setState({
            resource,
            loaded: false
        }, () => {
            console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
            this.getListPostedSchedulesArray();
            this.getListPreviousPostingsArrays();
        });
    }

    render() {
        if (this.props.user.securityLevels && this.state.listPostedSchedulesArray.length > 0 && this.props.listPreviousPostings && this.state.loaded) {
            return (
                <DashboardLayout>
                    <PageTitle title={'My Schedule'}
                        subTitle={this.state.resource.name || this.props.user.userDemographics.name} />
                    <Row gutter={32}>
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <Widget title='Posted Schedules'>
                                {AuthLogic.postedSchedules(this.props.user) &&
                                    (
                                        <React.Fragment>
                                            <PostedSchedulesList
                                                listPostedSchedulesArray={this.state.listPostedSchedulesArray}
                                                handleSelectSchedule={this.handleSelectSchedule}
                                            />

                                            { AuthLogic.previousPostings(this.props.user) &&
                                                (
                                                    <div style={{ marginBottom: 20 }}>
                                                        <a style={{ color: 'dodgerblue!important' }} onClick={this.handleClickPreviousPostings}>
                                                        {<StrokeIcon icon={'bookmarks'} style={{ marginRight: 20 }} />} Previous Postings
                                                        </a>
                                                            { this.state.displayPreviousPostings && this.state.listPreviousPostingsArrays &&

                                                                <PreviousPostingsList
                                                                    listPreviousPostingsArrays={this.state.listPreviousPostingsArrays}
                                                                    handleSelectSchedule={this.handleSelectSchedule}
                                                                />
                                                            }
                                                    </div>
                                                )
                                            }
                                        </React.Fragment>
                                    )
                                }
                               
                            </Widget>
                            {
                                AuthLogic.changeAssignmentsResource(this.props.user) &&
                                (<SelectResourceButton updatePageCallback={this.updateResource} />)
                            }
                        </Col>
                    </Row>
                </DashboardLayout>
            );
        } else return <Spinner />
    }
}

PostedSchedulesPage.propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    listPostedSchedules: PropTypes.object.isRequired,
    resources: PropTypes.object,
    postedSchedule: PropTypes.object,
    selectedResource: PropTypes.object,
    listPreviousPostings: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.user,
        listPostedSchedules: state.listPostedSchedules,
        resources: state.resources,
        postedSchedule: state.postedSchedules,
        selectedResource: state.selectedResource,
        listPreviousPostings: state.listPreviousPostings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            fetchListPostedSchedules: bindActionCreators(
                postedScheduleActions.fetchListPostedSchedules,
                dispatch
            ),
            fetchFindResource: bindActionCreators(
                resourceActions.fetchFindResource,
                dispatch
            ),
            fetchPostedSchedules: bindActionCreators(
                postedScheduleActions.fetchPostedSchedules,
                dispatch
            ),
            updateSelectedResource: bindActionCreators(
                resourceActions.updateSelectedResource,
                dispatch
            ),
            fetchListPreviousPostings: bindActionCreators(
                postedScheduleActions.fetchListPreviousPostings,
                dispatch
            ),
        }
    };
}

export const withRouter = (Component) => {
	const Wrapper = (props) => {
	const navigate = useNavigate();
		return <Component navigate={navigate} {...props}  />;
	};
	return Wrapper;
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(PostedSchedulesPage));
